/**
 * The history object must be the same throughout the app.
 *
 * If you want to use history, import from here!!
 *  */
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
